<template>
    <div class="range_wrapper">
        <canvas  ref="canvas-ref" @mousemove="move"/>
        <range-box :x="1" :y="2" :w="80" :h="45" :plow="v.predictionLow" :phigh="v.predictionHigh" :low="v.priorLow" :high="v.priorHigh" :last="v.actualPricePerShare" :fontsize="10"/>
    </div>
</template>
<script >

    import RangeBox from './RangeBox.vue';

    import vue from 'vue'

    export default vue.extend({
        template: '#range-template',
        components: {
            RangeBox
        },
        props:{
            v: {type:Object}
        },
        data() {
            return {
                provider: {
                    context: null
                }
            }
        },
        provide () {
            return {
                provider: this.provider
            }
        },
        methods:{
            move(evt){
               // console.log(evt.target)
            }
        },
        mounted () {

            this.provider.context = this.$refs['canvas-ref'].getContext('2d')

            // Resize the canvas to fit its parent's width.
            // Normally you'd use a more flexible resize system.
            this.$refs['canvas-ref'].width = 180 + 2
            this.$refs['canvas-ref'].height = 40+ 10
        }
    });
</script>

<style scoped>
    .range_wrapper{
        width: 180px;
        height: 40px;
    }
</style>